document.addEventListener('DOMContentLoaded', function() {

  // =========================
  // Helpers: producto y selección
  // =========================

  function getProductData(wrapper) {
    // Intenta leer JSON del producto (varios formatos comunes)
    const candidates = [
      wrapper && wrapper.querySelector('script[type="application/json"][data-product-json]'),
      wrapper && wrapper.querySelector('script[type="application/json"][id^="ProductJson"]'),
      wrapper && wrapper.querySelector('script[type="application/json"][id*="ProductJson"]'),
      document.querySelector('script[type="application/json"][data-product-json]'),
      document.querySelector('script[type="application/json"][id^="ProductJson"]'),
      document.querySelector('script[type="application/json"][id*="ProductJson"]')
    ].filter(Boolean);

    for (const s of candidates) {
      try {
        const data = JSON.parse(s.textContent);
        if (data && Array.isArray(data.variants)) return data;
      } catch (e) {}
    }
    return null;
  }

  function getSelectedColorOnPDP() {
    // PDP (página de producto): intentamos varias formas típicas
    const checked =
      document.querySelector('[data-option-name="Color"] input:checked') ||
      document.querySelector('input[name*="Color"]:checked') ||
      document.querySelector('select[name*="Color"]');

    if (!checked) return null;
    return checked.value ? String(checked.value).trim() : null;
  }

  function getSelectedSizeOnPDP() {
    const checked =
      document.querySelector('[data-option-name="Talla"] input:checked') ||
      document.querySelector('input[name*="Size"]:checked') ||
      document.querySelector('input[name*="Talla"]:checked') ||
      document.querySelector('select[name*="Talla"]');

    if (!checked) return null;
    return checked.value ? String(checked.value).trim() : null;
  }

  function variantAvailableForColorAndSize(productData, color, size) {
    if (!productData || !Array.isArray(productData.variants)) return true; // fail-open
    if (!color || !size) return true;

    // Asumimos que option1=Color y option2=Talla (lo más común).
    // Si tu producto está al revés, lo ajusto en 10 segundos.
    return productData.variants.some(v =>
      v.available === true &&
      String(v.option1 || '').trim() === color &&
      String(v.option2 || '').trim() === size
    );
  }

  function applyStrikeThroughOnPDP() {
    // Esta parte sirve para la página de producto (tallas S/M/L etc).
    const productData = getProductData(document);
    if (!productData) return;

    const color = getSelectedColorOnPDP();
    if (!color) return;

    // Botones de talla (según tu screenshot parecen ser botones/labels)
    // Ajusta el selector si tu theme usa otro contenedor:
    const sizeButtons = document.querySelectorAll('[data-option-name="Talla"] input[type="radio"], input[name*="Talla"][type="radio"], input[name*="Size"][type="radio"]');

    if (!sizeButtons.length) return;

    sizeButtons.forEach(input => {
      const size = String(input.value || '').trim();
      const ok = variantAvailableForColorAndSize(productData, color, size);

      // Ponemos la clase en el label para poder tachar con CSS
      const id = input.getAttribute('id');
      const label = (id && document.querySelector(`label[for="${CSS.escape(id)}"]`)) || input.closest('label');

      if (label) {
        label.classList.toggle('sold-out', !ok);
      }
    });
  }

  // =========================
  // TU CÓDIGO ORIGINAL (cards)
  // =========================

  // Manejar clics en tallas (cards)
  const clickableSizes = document.querySelectorAll('.clickable-size');

  clickableSizes.forEach(sizeItem => {
    sizeItem.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const wrapper = this.closest('.product-card-wrapper');
      const variantId = this.getAttribute('data-variant-id');
      const form = wrapper.querySelector('.product-card-form');
      const hiddenInput = form.querySelector('.selected-variant-id');
      const submitButton = form.querySelector('.product-card-add-button');

      // Remover selección previa en este producto
      wrapper.querySelectorAll('.clickable-size').forEach(item => {
        item.classList.remove('selected');
      });

      // Marcar esta talla como seleccionada
      this.classList.add('selected');

      // Actualizar variant ID en el formulario
      hiddenInput.value = variantId;

      // Habilitar botón y cambiar texto
      submitButton.disabled = false;
      submitButton.textContent = 'Agregar al carrito';
    });
  });

  // Manejar envío de formularios con AJAX
  const productForms = document.querySelectorAll('.product-card-form');

  productForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const submitButton = this.querySelector('.product-card-add-button');
      const variantId = this.querySelector('input[name="id"]').value;

      if (!variantId) {
        return;
      }

      // Cambiar texto del botón
      const originalText = submitButton.textContent;
      submitButton.textContent = 'Agregando...';
      submitButton.disabled = true;

      // Agregar al carrito con AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        // Éxito - mostrar feedback
        submitButton.textContent = '✓ Agregado';

        // Actualizar el contador del carrito si existe
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const cartCount = document.querySelector('.cart-count, [data-cart-count], .header__cart-count');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            }

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          });

        setTimeout(() => {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        submitButton.textContent = 'Error';
        setTimeout(() => {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }, 2000);
      });
    });
  });

  // =========================
  // NUEVO: Recalcular tachado en PDP cuando cambie Color/Talla
  // =========================
  applyStrikeThroughOnPDP();

  document.addEventListener('change', function(e) {
    const t = e.target;
    if (!t) return;

    // Si cambió Color o Talla, recalcular
    if (
      t.matches('[data-option-name="Color"] input, input[name*="Color"], select[name*="Color"]') ||
      t.matches('[data-option-name="Talla"] input, input[name*="Talla"], input[name*="Size"], select[name*="Talla"]')
    ) {
      applyStrikeThroughOnPDP();
    }
  });

});